module.exports = __webpack_public_path__ + "static/media/no_contact.55984319.svg";